<!--  -->
<template>
  <div class="detail-container">
    <!-- 优惠价格 -->
    <div class="price" :class="{ 'price-small': smallFlag }" v-text="item.discountFee"></div>
    <!-- 减免信息 -->
    <div class="discount-detail" :class="{ 'discount-detail-small': smallFlag }">
      <!-- 减免类型 -->
      <div :class="couponName == '活动价' ? 'discount-type-price' : 'discount-type'" v-text="couponName"></div>
      <!-- 减免详情 -->
      <div v-if="item.couponRuleDesc" class="discount-info" v-html="couponRuleDesc"></div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
const couponName = {
  // 券名字
  0: '优惠券',
  1: '代金券',
  2: '满减活动',
  3: '活动价',
  4: '当前售价', //指原价
  5: '定金预售'
}
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    smallFlag: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    couponName() {
      return couponName[this.item.couponFlag]
    },
    couponRuleDesc() {
      var reg = /[0-9]+(\.?[0-9]+)?\%?/g
      return this.item.couponRuleDesc?.replace(reg, '<strong style="font-weight:bold">$&</strong>')
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.detail-container {
  min-width: 150px;
  //margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .price {
    height: 45px;
    text-align: center;
    font-style: normal;
    @include os-font-weight(45, 40);
    font-size: 45px;
    line-height: 45px;
    color: #f10313;
    &::before {
      content: '\ffe5';
      font-style: normal;
      @include os-font-weight(36, 50);
      font-size: 36px;
      line-height: 36px;
      color: #f10313;
      letter-spacing: -3px;
    }
  }
  .price-small {
    height: 36px;
    font-size: 36px;
    line-height: 36px;
    &::before {
      font-size: 34px;
      line-height: 34px;
    }
  }
  .discount-detail {
    min-width: 102px;
    max-width: 277px;
    margin-top: 14px;
    border: 0.7px solid rgba(241, 3, 19, 0.3);
    border-radius: 12px;
    overflow: hidden;
    .discount-type {
      padding: 5px 14px;
      font-style: normal;
      font-size: 30px;
      line-height: 37px;
      text-align: center;
      color: #f10313;
      mix-blend-mode: normal;
      -webkit-text-size-adjust: none;
      background: linear-gradient(93.22deg, rgba(255, 67, 52, 0.12) 15.04%, rgba(255, 135, 23, 0.12) 92.31%);
    }
    .discount-type-price {
      padding: 5px 14px;
      font-style: normal;
      font-size: 30px;
      line-height: 37px;
      text-align: center;
      color: #ff4335;
      mix-blend-mode: normal;
      background: linear-gradient(93.22deg, rgba(255, 67, 52, 0.12) 15.04%, rgba(255, 135, 23, 0.12) 92.31%);
    }
    .discount-info {
      padding: 12px 14px 10px 14px;
      font-style: normal;
      font-size: 30px;
      line-height: 37px;
      /* or 100% */
      color: #ff4335;
      mix-blend-mode: normal;
      text-align: left;
    }
  }
  .discount-detail-small {
    .discount-type {
      font-size: 27px;
      line-height: 30px;
    }
    .discount-type-price {
      font-size: 27px;
      line-height: 30px;
    }
    .discount-info {
      font-size: 27px;
      line-height: 30px;
    }
  }
}
</style>
